const Svg = ({ children, ...props }) => (
  <svg
    aria-hidden='true'
    focusable='false'
    {...props}
  >
    {children}
  </svg>
);

const stroke = (width, viewBox = '0 0 16 16') => ({ viewBox, fill: 'none', stroke: 'currentColor', strokeWidth: width });

export const ArrowIcon = (props) => (
  <Svg
    {...stroke(1.6)}
    {...props}
  >
    <path d='M3 8h10M9 4l4 4-4 4' />
  </Svg>
);

export const ArrowRightIcon = (props) => (
  <Svg
    {...stroke(1.8)}
    {...props}
  >
    <path d='M3 8h10M9 4l4 4-4 4' />
  </Svg>
);

export const ArrowLeftIcon = (props) => (
  <Svg
    {...stroke(1.8)}
    {...props}
  >
    <path d='M13 8H3M7 4L3 8l4 4' />
  </Svg>
);

export const PlayIcon = (props) => (
  <Svg
    viewBox='0 0 16 16'
    fill='currentColor'
    {...props}
  >
    <path d='M5 3.5v9l7.5-4.5z' />
  </Svg>
);

export const PlayFilledIcon = (props) => (
  <Svg
    viewBox='0 0 16 16'
    fill='currentColor'
    {...props}
  >
    <path d='M4 2.5v11l9.5-5.5z' />
  </Svg>
);

export const CartIcon = (props) => (
  <Svg
    {...stroke(1.6, '0 0 20 20')}
    {...props}
  >
    <path d='M3 5h2l2 9h8l2-6H6.5' />
    <circle
      cx='8'
      cy='17'
      r='1'
    />
    <circle
      cx='14'
      cy='17'
      r='1'
    />
  </Svg>
);

export const BoxIcon = (props) => (
  <Svg
    {...stroke(1.6, '0 0 20 20')}
    {...props}
  >
    <path d='M3 6.5 10 3l7 3.5v7L10 17l-7-3.5z' />
    <path d='M3 6.5 10 10l7-3.5M10 10v7' />
  </Svg>
);

export const WrenchIcon = (props) => (
  <Svg
    {...stroke(1.6, '0 0 20 20')}
    {...props}
  >
    <path d='M12.5 3.5a4 4 0 0 0-4.7 5.3L3.5 13a1.8 1.8 0 0 0 2.5 2.5l4.2-4.3a4 4 0 0 0 5.3-4.7l-2.4 2.4-2-.5-.5-2z' />
  </Svg>
);

export const ChartIcon = (props) => (
  <Svg
    {...stroke(1.6, '0 0 20 20')}
    {...props}
  >
    <path d='M3 17h14M5.5 14V9M10 14V5M14.5 14v-3' />
  </Svg>
);

export const TagIcon = (props) => (
  <Svg
    {...stroke(1.6, '0 0 20 20')}
    {...props}
  >
    <path d='M3 10.2V4a1 1 0 0 1 1-1h6.2l6.8 6.8-7.2 7.2z' />
    <circle
      cx='7'
      cy='7'
      r='1.2'
    />
  </Svg>
);

export const MicIcon = (props) => (
  <Svg
    {...stroke(1.8, '0 0 24 24')}
    {...props}
  >
    <rect
      x='9'
      y='3'
      width='6'
      height='11'
      rx='3'
    />
    <path d='M5 11a7 7 0 0 0 14 0M12 18v3' />
  </Svg>
);

export const CloseIcon = (props) => (
  <Svg
    {...stroke(1.8)}
    strokeLinecap='round'
    {...props}
  >
    <path d='M3.5 3.5l9 9M12.5 3.5l-9 9' />
  </Svg>
);

export const CheckIcon = (props) => (
  <Svg
    {...stroke(2)}
    strokeLinecap='round'
    {...props}
  >
    <path d='M3 8.5l3.2 3L13 4.5' />
  </Svg>
);

export const TickIcon = (props) => (
  <Svg
    viewBox='0 0 12 12'
    {...props}
  >
    <path d='M2.5 6.2l2.3 2.3 4.7-5' />
  </Svg>
);

export const DoneIcon = (props) => (
  <Svg
    viewBox='0 0 24 24'
    fill='none'
    stroke='#02231F'
    strokeWidth='2.6'
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  >
    <path d='M5 12.5l4.5 4.5L19 7.5' />
  </Svg>
);

export const PaperclipIcon = (props) => (
  <Svg
    {...stroke(1.6, '0 0 24 24')}
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  >
    <path d='M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48' />
  </Svg>
);

export const AppleIcon = (props) => (
  <Svg
    viewBox='0 0 24 24'
    fill='currentColor'
    {...props}
  >
    <path d='M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701' />
  </Svg>
);

export const GooglePlayIcon = (props) => (
  <Svg
    viewBox='0 0 24 24'
    fill='currentColor'
    {...props}
  >
    <path d='M22.018 13.298l-3.919 2.218-3.515-3.493 3.543-3.521 3.891 2.202a1.49 1.49 0 0 1 0 2.594zM1.337.924a1.486 1.486 0 0 0-.112.568v21.017c0 .217.045.419.124.6l11.155-11.087L1.337.924zm12.207 10.065l3.258-3.238L3.45.195a1.466 1.466 0 0 0-.946-.179l11.04 10.973zm0 2.067l-11 10.933c.298.036.612-.016.906-.183l13.324-7.54-3.23-3.21z' />
  </Svg>
);

export const FacebookIcon = (props) => (
  <Svg
    viewBox='0 0 24 24'
    fill='currentColor'
    {...props}
  >
    <path d='M13.5 21v-7.5h2.6l.4-3h-3V8.6c0-.9.3-1.5 1.6-1.5h1.6V4.4c-.3 0-1.2-.1-2.3-.1-2.3 0-3.9 1.4-3.9 4v2.2H7.9v3h2.6V21z' />
  </Svg>
);

export const InstagramIcon = (props) => (
  <Svg
    {...stroke(1.8, '0 0 24 24')}
    {...props}
  >
    <rect
      x='3.5'
      y='3.5'
      width='17'
      height='17'
      rx='5'
    />
    <circle
      cx='12'
      cy='12'
      r='4'
    />
    <circle
      cx='17.2'
      cy='6.8'
      r='1'
      fill='currentColor'
      stroke='none'
    />
  </Svg>
);

export const LinkedInIcon = (props) => (
  <Svg
    viewBox='0 0 24 24'
    fill='currentColor'
    {...props}
  >
    <path d='M5.2 8.6h3.1V19H5.2zM6.8 3.9a1.8 1.8 0 1 1 0 3.6 1.8 1.8 0 0 1 0-3.6M10.3 8.6h3v1.4h.1c.4-.8 1.5-1.7 3-1.7 3.2 0 3.8 2.1 3.8 4.8V19H17v-5.1c0-1.2 0-2.8-1.7-2.8s-2 1.3-2 2.7V19h-3z' />
  </Svg>
);
